import React from 'react';
import { Search, Filter } from 'lucide-react';
import MarketReviewFilterPanel from './MarketReviewFilterPanel';
import type { MarketReviewFilter } from '../../types/market-review';

interface MarketReviewFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  isFilterOpen: boolean;
  onFilterToggle: () => void;
  filters: MarketReviewFilter;
  onFilterChange: (filters: Partial<MarketReviewFilter>) => void;
  reviewTypes: string[];
  lots: string[];
  reviewTypeMap?: Record<string, string>;
}

export default function MarketReviewFilters({
  searchQuery,
  onSearchChange,
  isFilterOpen,
  onFilterToggle,
  filters,
  onFilterChange,
  reviewTypes,
  lots,
  reviewTypeMap = {}
}: MarketReviewFiltersProps) {
  return (
    <div className="flex items-center gap-2">
      <div className="relative">
        <input
          type="text"
          placeholder="Search market reviews..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
        />
        <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
      </div>
      <div className="relative">
        <button
          onClick={onFilterToggle}
          className="flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
        >
          <Filter className="h-5 w-5 mr-2" />
          Filters
          {Object.values(filters).filter(Boolean).length > 0 && (
            <span className="ml-2 bg-primary text-white text-xs rounded-full px-2 py-0.5">
              {Object.values(filters).filter(Boolean).length}
            </span>
          )}
        </button>
        <MarketReviewFilterPanel
          isOpen={isFilterOpen}
          onClose={onFilterToggle}
          filters={filters}
          onFilterChange={onFilterChange}
          reviewTypes={reviewTypes}
          lots={lots}
          reviewTypeMap={reviewTypeMap}
        />
      </div>
    </div>
  );
}
